import type { AccountHistory } from '@api/hooks/useHistory';
import { Typography } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';

const SingleAccountCellItem = ({
	date,
	payer,
	beneficiary,
	documentNumber,
	details,
	amount,
}: Partial<AccountHistory>) => {
	const { t } = useTranslation('', { keyPrefix: 'accountStatement' });

	return (
		<div className="flex flex-col gap-space-16">
			<span>
				<Typography className="text-neutral-600 font-medium" level="small-text">
					{t('tableHeaders.date')}
				</Typography>
				<Typography className="block font-medium" level="small-text">
					{date}
				</Typography>
			</span>
			<span>
				<Typography className="text-neutral-600 font-medium" level="small-text">
					{t('tableHeaders.sender')}
				</Typography>
				<Typography className="block font-bold" level="small-text">
					{payer?.iban}
				</Typography>
				<Typography className="block text-neutral-600 font-medium" level="small-text">
					{payer?.name}
				</Typography>
			</span>
			<span>
				<Typography className="text-neutral-600 font-medium" level="small-text">
					{t('tableHeaders.beneficiary')}
				</Typography>
				<Typography className="block font-bold" level="small-text">
					{beneficiary?.iban}
				</Typography>
				<Typography className="text-neutral-600 font-medium" level="small-text">
					{beneficiary?.name}
				</Typography>
			</span>
			<span>
				<Typography className="text-neutral-600 font-medium" level="small-text">
					{t('tableHeaders.docNo')}
				</Typography>
				<Typography className="block font-medium" level="small-text">
					{documentNumber}
				</Typography>
			</span>
			<span>
				<Typography className="text-neutral-600 font-medium" level="small-text">
					{t('tableHeaders.operation')}
				</Typography>
				<Typography className="block font-medium" level="small-text">
					{details}
				</Typography>
			</span>
			<span>
				<Typography className="text-neutral-600 font-medium" level="small-text">
					{t('tableHeaders.amount')}
				</Typography>
				<Typography className="block font-bold" level="small-text">
					{amount?.display}
				</Typography>
			</span>
		</div>
	);
};

export default SingleAccountCellItem;
